import { defineComponent as u, createElementBlock as d, openBlock as s, Fragment as p, createBlock as i, createCommentVNode as a, createVNode as o, normalizeProps as g, guardReactiveProps as c, unref as $, withCtx as e, createSlots as l, renderSlot as r, createElementVNode as k, toDisplayString as b } from "vue";
import I from "./Login.vue2.js";
import S from "./LoginMainHeader.vue2.js";
import y from "./LoginMainBody.vue2.js";
import _ from "./LoginMainFooter.vue2.js";
import v from "./LoginHeader.vue2.js";
import P from "./LoginFooter.vue2.js";
import A from "../Brand.vue2.js";
import C from "../List/List.vue2.js";
import V from "../BackgroundImage.vue2.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const q = /* @__PURE__ */ u({
  name: "PfLoginPage",
  inheritAttrs: !1,
  __name: "LoginPage",
  props: {
    brandImgSrc: {},
    brandImgAlt: {},
    backgroundImgSrc: {},
    backgroundImgAlt: {},
    textContent: {},
    footerListVariants: {},
    title: {},
    subtitle: {}
  },
  setup(m) {
    const n = m, f = h({ id: n.ouiaId, safe: n.ouiaSafe });
    return (t, L) => (s(), d(p, null, [
      t.backgroundImgSrc ? (s(), i(V, {
        key: 0,
        src: t.backgroundImgSrc
      }, null, 8, ["src"])) : a("", !0),
      o(I, g(c({ ...$(f), ...t.$attrs })), {
        header: e(() => [
          o(v, null, {
            default: e(() => [
              t.brandImgSrc ? (s(), i(A, {
                key: 0,
                src: t.brandImgSrc,
                alt: t.brandImgAlt
              }, null, 8, ["src", "alt"])) : a("", !0)
            ]),
            _: 1
          })
        ]),
        footer: e(() => [
          o(P, null, {
            default: e(() => [
              k("p", null, b(t.textContent), 1),
              o(C, { variant: t.footerListVariants }, {
                default: e(() => [
                  r(t.$slots, "footer-list-items")
                ]),
                _: 3
              }, 8, ["variant"])
            ]),
            _: 3
          })
        ]),
        default: e(() => [
          o(S, {
            title: t.title,
            subtitle: t.subtitle
          }, l({ _: 2 }, [
            t.$slots.utilities ? {
              name: "utilities",
              fn: e(() => [
                r(t.$slots, "utilities")
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["title", "subtitle"]),
          o(y, null, {
            default: e(() => [
              r(t.$slots, "default")
            ]),
            _: 3
          }),
          t.$slots.social || t.$slots["forgot-credentials"] || t.$slots.signup ? (s(), i(_, { key: 0 }, l({ _: 2 }, [
            t.$slots.social ? {
              name: "social",
              fn: e(() => [
                r(t.$slots, "social")
              ]),
              key: "0"
            } : void 0,
            t.$slots["forgot-credentials"] ? {
              name: "forgot-credentials",
              fn: e(() => [
                r(t.$slots, "forgot-credentials")
              ]),
              key: "1"
            } : void 0,
            t.$slots.signup ? {
              name: "signup",
              fn: e(() => [
                r(t.$slots, "signup")
              ]),
              key: "2"
            } : void 0
          ]), 1024)) : a("", !0)
        ]),
        _: 3
      }, 16)
    ], 64));
  }
});
export {
  q as default
};
